import { error } from 'toastr';
import * as actionsTypes from './actionsTypes';

const initialState = {
  surveyTemplatesLength: 0,
  surveyTemplates: [],
  surveyTemplate: {},
  isLoading: false,
  isFormSaving: false,
  error: "",
  formError: "",
}

export default function surveyTemplateReducer(state = initialState, action){
  switch (action.type) {
    case actionsTypes.FETCH_SURVEY_TEMPLATE_REQUEST:
      return {...state, isLoading: action.payload}
    case actionsTypes.FETCH_SURVEY_TEMPLATES_REQUEST:
      return {...state, isLoading: action.payload}
    case actionsTypes.CREATE_SURVEY_TEMPLATE_REQUEST:
      return {...state, isFormSaving: action.payload}
    case actionsTypes.UPDATE_SURVEY_TEMPLATE_REQUEST:
      return {...state, isFormSaving: action.payload}
    case actionsTypes.FETCH_SURVEY_TEMPLATES_SUCCESS:
      return {...state, 
                 surveyTemplates: action.payload.data, 
                 surveyTemplatesLength: action.payload.count, error: "",
                 formError: ""}
    case actionsTypes.FETCH_SURVEY_TEMPLATE_SUCCESS:
      return {...state, surveyTemplate: action.payload};
    case actionsTypes.FETCH_SURVEY_TEMPLATES_FAILURE:
      return { ...state, error: action.payload };
    case actionsTypes.FETCH_SURVEY_TEMPLATE_FAILURE:
      return { ...state, error: action.payload };
    case actionsTypes.CREATE_SURVEY_TEMPLATE_SUCCESS:
      return {...state, surveyTemplate: action.payload, formError:""}
    case actionsTypes.CREATE_SURVEY_TEMPLATE_FAILURE:
      return { ...state, formError: action.payload };
    case actionsTypes.UPDATE_SURVEY_TEMPLATE_SUCCESS:
      return {...state, surveyTemplate: action.payload, formError:""}
    case actionsTypes.UPDATE_SURVEY_TEMPLATE_FAILURE:
      return { ...state, formError: action.payload };
    case actionsTypes.DELETE_SURVEY_TEMPLATE_SUCCESS:
      const surveyTemplates = state.surveyTemplates.filter(surveyTemplate => surveyTemplate.id !== action.payload);
      return {...state, surveyTemplates: surveyTemplates, error: ""}
    case actionsTypes.DELETE_SURVEY_TEMPLATE_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}